'use strict';
import * as T from 'prop-types';


export const ScheduleModalMode = {
  /**
   * @type {ScheduleModalMode} Opening in the context of the current task's environment.
   * Do not provide a link to navigate to the task.
   */
  local: 'local',
  /**
   * @type {ScheduleModalMode} Opening outside of the context of the current task's environment.
   * Provide a link to navigate to the task.
   */
  foreign: 'foreign',
};

export const isScheduleModalMode = T.oneOf(Object.values(ScheduleModalMode));

/**
 * @typedef {String} ScheduleModalMode
 */



// WEBPACK FOOTER //
// ./src/js/tasks/enums/ScheduleModalMode.js